export default "__VITE_ASSET__BWGSgOha__"